<template>
	<div >
		<nav-header :navText="headerText" class="mb-3" />
		<b-tabs content-class="mt-3 mx-4" v-model="tabIndex">

			<b-tab title="Click & Collect Desk" href="#desk" @click="tabEvent('#desk')" v-if="clickandcollectEnabled == 1">
				<b-row>
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekOneData" :admin="true" :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekTwoData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row>
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekThreeData" :admin="true"  :dataView="dataView"  @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekFourData" :admin="true"  :dataView="dataView"  @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
			</b-tab>
			<b-tab title="Click & Collect Locker" href="#locker" @click="tabEvent('#locker')" v-if="lockerEnabled == 1">
				<b-row>
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekOneLockerData" :admin="true" :dataView="dataView"  @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekTwoLockerData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row>
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekThreeLockerData"  :dataView="dataView" :admin="true" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekFourLockerData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>			
			</b-tab>
			<b-tab title="Delivery" href="#delivery" @click="tabEvent('#delivery')" v-if="deliveryEnabled == 1">
				<b-row>
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid :slots="weekOneDeliveryData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid :slots="weekTwoDeliveryData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row >
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid :slots="weekThreeDeliveryData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourDeliveryDateRange }} - Delivery Calendar</strong><week-slots-grid :slots="weekFourDeliveryData" :admin="true"  :dataView="dataView" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>			
			</b-tab>
			<template v-slot:tabs-end>
			<span class="ml-4 pl-4 pt-2"><b-form-radio-group v-model='dataView' :options='dataViewOptions' class="inline-radio"></b-form-radio-group>			
				</span>
				<div class="statusKeyContainer"><ul class="statusKeyList"><li><strong>Key: </strong></li><li class="statusKey sk-available">Available</li><li class="statusKey sk-booked">Booked</li><li class="statusKey sk-closed">Admin Closed</li><li class="statusKey sk-unavailable">Unavailable</li></ul></div>
			</template>
		</b-tabs>
		<b-modal id="formModal" :title="'Add ' + typeText" hide-footer  no-close-on-esc no-close-on-backdrop hide-header-close>
			<b-row>
				<b-col>
					<div v-if="!inCredit">
					<p>Unfortunately there is insufficient credit to add any further orders - please top up your account using the link below:</p>
						<b-button href="http://localhost/scanandget/public_html/billing/billing.php#tabs-4">Add Credit</b-button>
						<b-button  class="float-right" variant="danger" @click="cancel()">Cancel</b-button>
					</div>
					<b-form @submit="onSubmit" @reset="onReset" class="text-left" validated ref="formContainer" v-if="inCredit">
						<div v-if="!formSubmitted">
						<p><strong> {{ selectedSlotDate |  moment("ddd D MMM")  }} {{ selectedSlotTime }}</strong></p>
						<b-form-group id="customerNameGroup" description="Salutaion in SMS message text.">
							<label for="customer-name" class="sr-only">Customer Name</label>
							<b-form-input
							id="customerName"
							v-model="form.customerName"
							required
							:state="customerNameState"
							placeholder="Enter customer name"
							></b-form-input>
							<b-form-invalid-feedback>A customer name is required (min. 2 characters)</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group id="orderMobileNumberGroup" description="The mobile number where the SMS collection details will be sent to.">
							<label for="orderMobileNumber" class="sr-only">Mobile number</label>
							<b-form-input
							id="orderMobileNumber"
							v-model="form.orderMobileNumber"
							:state="orderMobileNumberState"
							type="tel"
							required
							maxlength="11"
							minlength="11"
							trim
							placeholder="Order mobile number"
							></b-form-input>
							<b-form-invalid-feedback>A valid 11 digit UK mobile number is required (starting 07)</b-form-invalid-feedback>
						</b-form-group>
						
					<!--	<b-form-group id="orderEmailGroup" description="">
							<label for="orderEmail" class="sr-only">Email address</label>
							<b-form-input
							id="orderEmail"
							v-model="form.orderEmail"
							:state="orderEmailState"
							type="email"
							required
							placeholder="Order Email"
							></b-form-input>
							<b-form-invalid-feedback>Please enter a valid email address</b-form-invalid-feedback>			
						</b-form-group> -->
						
						<b-form-group id="orderIdGroup" description="">
							<label for="orderId" class="sr-only">Order Id</label>
							<b-form-input
							id="orderId"
							v-model="form.orderId"
							:state="orderIdState"
							type="text"
							required
							placeholder="Order Id"
						></b-form-input>
						<b-form-invalid-feedback>An order id is required</b-form-invalid-feedback>
						</b-form-group>
						
					
							<b-button type="submit" variant="primary" class="mr-2" :disabled="submitDisabled">Submit</b-button>
							<b-button type="reset" variant="danger" class="mr-2">Clear form</b-button>
							<b-button  variant="danger" @click="cancel()">Cancel</b-button>
						</div>
					</b-form>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
import NavHeader from './NavHeader'
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
import EventBus from './../eventBus';
//const SlotsRepo = RepositoryFactory.get('slots')
const SlotsRepoPost = RepositoryFactory.post('slots')
import WeekSlotsGrid from './WeekSlotsGrid'
//import moment from 'moment'
export default{
	name: 'DesktopConfigureSlotCalendar',
	components: {WeekSlotsGrid, NavHeader},
	mixins: [mixin],
		data(){
			return{
				renderKey: 0,
				tabIndex: 0,
				clickandcollectEnabled: this.$store.state.settings.clickandcollectEnabled,
				lockerEnabled: this.$store.state.settings.lockerEnabled,
				deliveryEnabled: this.$store.state.settings.deliveryEnabled,
				tabs: ['#desk', '#locker', '#delivery'],
				headerText: "Click&Collect - Manage Slots",
				weekOneDateRange : "",
				weekOneData: [],
				weekTwoDateRange : "",
				weekTwoData: [],				
				weekThreeDateRange : "",				
				weekThreeData: [],
				weekFourDateRange : "",				
				weekFourData: [],
				weekOneLockerDateRange : "",
				weekOneLockerData: [],
				weekTwoLockerDateRange : "",
				weekTwoLockerData: [],				
				weekThreeLockerDateRange : "",				
				weekThreeLockerData: [],
				weekFourLockerDateRange : "",				
				weekFourLockerData: [],
				weekOneDeliveryDateRange : "",
				weekOneDeliveryData: [],
				weekTwoDeliveryDateRange : "",
				weekTwoDeliveryData: [],				
				weekThreeDeliveryDateRange : "",				
				weekThreeDeliveryData: [],
				weekFourDeliveryDateRange : "",				
				weekFourDeliveryData: [],
				form: {
					customerName: '',
					orderEmail: '',
					orderMobileNumber: '',
					orderId: '',
					slotId:	'',
					slotType: '',
					slotTime: '',
					storeId: '',
					storeShortName: "",
					identifyType: this.$store.state.settings.identifyType,
				},
				typeText: '',
				selectedSlotDay: '',
				selectedSlotDate: '',
				selectedSlotTime: '',
				selectedSlotId: '',
				selectedSlotType: '',
				fullPage: false,
				formSubmitted: false,
				inCredit: true,
				dataView: true,
				dataViewOptions:[
				{ value: true, text: 'Data View'},
				{ value: false, text: 'Availability View'}
				]
		}
	},
	created(){
	
		if(this.$store.state.settings.clickandcollectEnabled == 1)
		{
			this.fetchGetClickAndCollectSlotsDesktop();
		}
		
		if(this.$store.state.settings.lockerEnabled == 1)
		{
			this.fetchGetLockerSlotsDesktop();
		}
		
		if(this.$store.state.settings.deliveryEnabled == 1)
		{
			this.fetchGetDeliverySlotsDesktop();
		}
	},
	methods:{
		cancel(){
			this.$bvModal.hide("formModal")
		},
		reloadPage(){
			location.reload('http://localhost:8081/#locker');
		},
		showFormModal(event){
			console.log(event)
			//this.typeText = (event.slotType === 'locker')? 'Locker Booking' : 'Click and Collect Booking'
			switch(event.slotType)
			{
				case 'locker':
				this.typeText = 'Locker Booking';
				break;
				case 'clickandcollect':
				this.typeText = 'Click and Collect Booking';
				break;
				case 'delivery':
				this.typeText = 'Delivery';
				break
			}
			this.selectedSlotDay = event.slotDay
			this.selectedSlotDate = event.slotDate
			this.selectedSlotTime = event.slotTime
			this.selectedSlotType = event.slotType
			this.form.slotType = event.slotType
			this.form.slotDate = event.slotDate
			this.form.slotTime = event.slotTime
			this.form.slotId = event.slotId
			this.form.storeId = this.$store.state.storeId
			this.form.storeShortName = this.$store.state.settings.storeShortName
			this.$bvModal.show("formModal")
		},		
		onSubmit(evt) {
			console.log(evt)
			evt.preventDefault()
			this.PostAddBooking()
			this.formSubmitted = true
			let loader = this.$loading.show({
			container: this.fullPage ? null : this.$refs.formContainer,
			canCancel: false,
			onCancel: this.onCancel,
			loader: 'dots',
			color: 'green',
			opacity: 0.5,
			});
			
			this.$nextTick().then(() => {
				setTimeout(() => {
				loader.hide()	
				this.reloadPage()				
			}, 1500)
			});				

					
		},
		emitMethod(){
			EventBus.$emit('ForceUpdate');
		},
		onReset(evt) {
			evt.preventDefault()
			// Reset our form values
				this.form.orderEmail = ''
				this.form.customerName = ''
				this.form.orderMobileNumber= ''
				this.form.orderId = ''
			// Trick to reset/clear native browser form validation state
				this.show = false
				this.$nextTick(() => {
				this.show = true
			})
		},
		async PostAddBooking(){
		var payload = new FormData();
		for ( var key in this.form ) {
			payload.append(key, this.form[key]);
		}	
			console.log(payload)
			await SlotsRepoPost.postAddSlotBooking(payload)
		},
		tabEvent(hash)
		{
			window.location = hash
		}
	},
	computed:{
		customerNameState(){
			return this.form.customerName.length >= 2 ? true : false;
		},
//		orderEmailState(){
//			return this.form.orderEmail.length == "derekmwanza@hotmail.co.uk" ? true: false; 
//		},
		orderIdState(){
			return this.form.orderId.length >= 2? true : false;
		},
		orderMobileNumberState: {
			get: function () {
				let isValid = true
				let mNumber = this.form.orderMobileNumber
				let starts07 = mNumber.substring(0,2)
				if(mNumber.length != 11 || starts07 != "07")
				{
					isValid = false
				}		
				return isValid
			},
			set: function () {
				
			}			
		},
		submitDisabled: {
			get: function () {
				let isDisabled = false
				if(!this.orderMobileNumberState || !this.customerNameState || !this.orderIdState)
				{
					isDisabled = true
				}		
				return isDisabled
			},
			set: function () {
				
			}			
		}
	},
	mounted() {
		this.tabIndex = this.tabs.findIndex(tab => tab === this.$route.hash)			
	}
}

</script>

<style>
.vld-icon {
    text-align: center
}

.statusKeyContainer{
	margin-left: 100px;
    padding-top: 6px;
}

.statusKeyList
{
	list-style-type: none;
}

.statusKey{
color: #000000;
}

.statusKey.sk-available{
background-color: #69d081;
}

.statusKey.sk-booked{
background-color: orange;
}

.statusKey.sk-closed{
background-color: #c0c0c0;
}

.statusKey.sk-unavailable{
background-color: #f9465a;
}

.statusKeyList li
{
	display: inline;
	padding: 5px 20px;
	border: 1px solid #c0c0c0;
	font-size: 0.8em;
}
</style>
